/*
 * @Author: zhushitao
 * @Date: 2021-08-23 11:35:41
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-10-28 14:48:11
 * @Description:
 */

import { Lifecycle } from '../constants/hooks';
import { Spectator } from '../lib/spectator';

/**
 * @description 长链类
 */
abstract class IChannel<T, B = any> extends Spectator {
  public instance?: B;
  public abstract pullMessages(params: any): Promise<any>;
  public abstract sendMessage(appContext: T, message: any): void;
  public abstract read(message?: any): any;
  public abstract init(appContext: T): Promise<any>;
  public emit(eventName: string, ...props: any) {
    return this.publish(eventName, ...props);
  }
  protected emitMessageChange(message: any) {
    return this.publish(Lifecycle.MESSAGE_CHANGE, message);
  }
  protected emitMessagesChange(messages: any) {
    return this.publish(Lifecycle.MESSAGES_CHANGE, messages);
  }
  protected emitDialogChange(dialog: any) {
    return this.publish(Lifecycle.DIALOG_CHANGE, dialog);
  }
}

export default IChannel;
